<template>
    <v-bottom-navigation v-model="activeNavigationIndex"
                         :height="bottomNavigationHeight"
                         app
                         fixed>
        <v-btn v-for="(navigationItem) in bottomNavigation"
               :key="navigationItem.name"
               :value="navigationItem.internalName"
               :to="navigationItem.to">
            <span v-if="navigationItem.name">{{ $vuetify.lang.t(navigationItem.name) }}</span>
            <v-expand-transition>
                    <span v-if="navigationItem.isAccount && user && user.wallet">
                        {{ user.wallet.balance | number | balance }}P
                    </span>
            </v-expand-transition>
            <v-img v-show="navigationItem.internalName === activeNavigationIndex"
                   :src="require(`../../assets/images/menu/${navigationItem.iconActive}`)"
                   class="mb-1"
                   max-width="25px"
                   width="100%"
                   min-height="20px"
                   max-height="20px"
                   contain></v-img>

            <v-img v-show="navigationItem.internalName !== activeNavigationIndex"
                   :src="require(`../../assets/images/menu/${navigationItem.icon}`)"
                   class="mb-1"
                   max-width="25px"
                   width="100%"
                   min-height="20px"
                   max-height="20px"
                   contain></v-img>
        </v-btn>
    </v-bottom-navigation>
</template>
<script>
    // utils
    import {
        ROUTE_ACCOUNT,
        ROUTE_DASHBOARD,
        ROUTE_NEWS,
        ROUTE_SHOP,
    } from '../../utils/constants';

    export default {
        name: 'app-bottombar',
        props: {
            user: {},
        },
        computed: {
            bottomNavigationHeight() {
                return this.$vuetify.breakpoint.smAndUp ? '100px' : '56px';
            },
        },
        data() {
            return {
                activeNavigationIndex: null,
                bottomNavigation: [
                    {
                        internalName: 'dashboard',
                        name: '$vuetify.bottom_navigation.home',
                        icon: 'home-inactive.svg',
                        iconActive: 'home-active.svg',
                        to: { name: ROUTE_DASHBOARD },
                    },
                    {
                        internalName: 'shop',
                        name: '$vuetify.bottom_navigation.shop',
                        icon: 'shop-inactive.svg',
                        iconActive: 'shop-active.svg',
                        to: { name: ROUTE_SHOP },
                    },
                    {
                        internalName: 'account',
                        isAccount: true,
                        icon: 'account-inactive.svg',
                        iconActive: 'account-active.svg',
                        to: { name: ROUTE_ACCOUNT },
                    },
                    {
                        internalName: 'news',
                        name: '$vuetify.bottom_navigation.news',
                        icon: 'news-inactive.svg',
                        iconActive: 'news-active.svg',
                        to: { name: ROUTE_NEWS },
                    },
                ],

            }
        },
        mounted() {
            this.$nextTick(async () => {
                this.activeNavigationIndex = this.$route.name;
            });
        }
    };
</script>
